import { SearchSlotsResponse } from '@cemex-core/cmx-api';
import { Action } from '@ngrx/store';
import * as moment from 'moment';

export enum SlotActionTypes {
  LOAD_SLOTS_OP = '[Rms Slots OP] Load',
  LOAD_SLOTS = '[Rms Slots] Load',
  LOAD_SLOTS_COMPLETED = '[Rms Slots] Load complete',
  RESET = '[Rms Slots] Reset',
  ERROR = '[Rms Slots] Error',
  SLOT_AVAILABLE = '[RMS Slots] Slot available',
  SCHEDULE_AVAILABLE = '[RMS Slots] Schedule available',
  SLOT_WAITING_LIST_DEFAULTED = '[RMS Slots] Waiting list defaulted',
}

export class LoadSlotsOpAction implements Action {
  readonly type = SlotActionTypes.LOAD_SLOTS_OP;

  constructor(public payload?: moment.Moment) {}
}

export class LoadSlotsAction implements Action {
  readonly type = SlotActionTypes.LOAD_SLOTS;

  constructor(public payload?: moment.Moment) {}
}

export class LoadSlotsCompleteAction implements Action {
  readonly type = SlotActionTypes.LOAD_SLOTS_COMPLETED;

  constructor(public payload: SearchSlotsResponse) {}
}

export class SlotsResetAction implements Action {
  readonly type = SlotActionTypes.RESET;

  constructor() {}
}

export class SlotsErrorAction implements Action {
  readonly type = SlotActionTypes.ERROR;

  constructor(public payload: any) {}
}

export class SlotAvailable implements Action {
  readonly type = SlotActionTypes.SLOT_AVAILABLE;

  constructor(public payload: moment.Moment | null) {}
}

export class ScheduleAvailable implements Action {
  readonly type = SlotActionTypes.SCHEDULE_AVAILABLE;

  constructor(public payload: boolean) {}
}

export class SlotWaitingListDefaulted implements Action {
  readonly type = SlotActionTypes.SLOT_WAITING_LIST_DEFAULTED;

  constructor(public payload: boolean) {}
}

export type SlotsActions =
  | LoadSlotsOpAction
  | LoadSlotsAction
  | LoadSlotsCompleteAction
  | SlotsResetAction
  | SlotsErrorAction
  | SlotAvailable
  | SlotWaitingListDefaulted;
